"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_property_decorator_1 = require("vue-property-decorator");
const vuex_1 = require("vuex");
const vehicle_detail_vue_1 = tslib_1.__importDefault(require("@/components/vehicle-detail/vehicle-detail.vue"));
const pls_price_ui_vue_1 = tslib_1.__importDefault(require("@/components/pls-price-ui/pls-price-ui.vue"));
const utils_1 = require("@/utils");
let VehicleSelectorMotorization = class VehicleSelectorMotorization extends vue_property_decorator_1.Vue {
    onClick() {
        this.$emit('click');
    }
    get shouldShowPls() {
        return utils_1.plsMarkets.includes(this.market);
    }
};
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true })
], VehicleSelectorMotorization.prototype, "id", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true })
], VehicleSelectorMotorization.prototype, "name", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true })
], VehicleSelectorMotorization.prototype, "price", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true })
], VehicleSelectorMotorization.prototype, "priceDescription", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], VehicleSelectorMotorization.prototype, "priceReferences", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], VehicleSelectorMotorization.prototype, "priceSuffix", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true })
], VehicleSelectorMotorization.prototype, "fuelType", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true })
], VehicleSelectorMotorization.prototype, "fuelTypeLabel", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true })
], VehicleSelectorMotorization.prototype, "power", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true })
], VehicleSelectorMotorization.prototype, "enginePowerLabel", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true })
], VehicleSelectorMotorization.prototype, "transmission", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true })
], VehicleSelectorMotorization.prototype, "transmissionLabel", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true })
], VehicleSelectorMotorization.prototype, "engineConcept", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true })
], VehicleSelectorMotorization.prototype, "hybridTranslation", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true })
], VehicleSelectorMotorization.prototype, "vehicle", void 0);
VehicleSelectorMotorization = tslib_1.__decorate([
    (0, vue_property_decorator_1.Component)({
        name: 'VehicleSelectorMotorization',
        components: { VehicleDetail: vehicle_detail_vue_1.default, PlsPriceUi: pls_price_ui_vue_1.default },
        computed: Object.assign({}, (0, vuex_1.mapGetters)(['market'])),
    })
], VehicleSelectorMotorization);
exports.default = VehicleSelectorMotorization;
